import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import useHandleForm from "./useHandleForm";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {
  const {
    data,
    detailList,
    activityList,
    materialsList,
    momentList,
    actionTypeList,
    handleClose,
    setParentFormValue,
  } = props;

  const dispatch = useDispatch();

  const create = (dataToSend) => {
    const newItems = [...detailList, { ...dataToSend, number: detailList.length }];
    setParentFormValue(newItems.map((item, index) => ({ ...item, number: index + 1 })), "details");
    handleClose();
  }

  const modify = (dataToSend) => {
    let itemsClone = [...detailList];
    let elementToChange = itemsClone.findIndex((item) => item.number === dataToSend.number);

    if (elementToChange > -1) {
      itemsClone[elementToChange] = dataToSend;
      setParentFormValue(itemsClone.map((item, index) => ({ ...item, number: index + 1 })), "details");
    }

    handleClose();
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit,
  } = useHandleForm(detailList, data, create, modify, openValidationError);

  return (
    <>
      <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
        <Grid container item xs={12}>
          <Grid container item alignItems="center" xs={4} style={gridStyle}> {/* Pregunta */}
            <TextField
              required
              fullWidth
              margin={"none"}
              label={getLocalizedString("stepName")}
              value={formData.name}
              onChange={(e) => setFormValue(e.target.value, "name")}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={4} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={'label-moment'}>{getLocalizedString("moment")}</InputLabel>
              <Select
                value={formData.moment}
                labelId={'label-moment'}
                id={'select-moment'}
                onChange={(e) => setFormValue(e.target.value, "moment", formData.materials)}
                margin={"none"}
              >
                {
                  momentList?.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}
                    >
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={4} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={'label-actionType'}>{getLocalizedString("actionType")}</InputLabel>
              <Select
                value={formData.actionType}
                labelId={'label-actionType'}
                id={'select-actionType'}
                onChange={(e) => setFormValue(e.target.value, "actionType", formData.materials)}
                margin={"none"}
              >
                {
                  actionTypeList?.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.code}
                      value={item.code}
                    >
                      {item.name}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={12} style={{ ...gridStyle, marginBottom: 70 }}>
            <TextFieldMultiline
              fullWidth
              label={getLocalizedString("stepDescription")}
              rows={5}
              margin={"none"}
              value={formData.comment}
              onChange={(e) => setFormValue(e.target.value, "comment")}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id={'label-materials'}>{getLocalizedString("materialsOrResources")}</InputLabel>
              <Select
                value={formData.materials}
                labelId={'label-materials'}
                id={'select-materials'}
                onChange={(e) => setFormValue(e.target.value, "materials")}
                margin={"none"}
                multiple
              >
                {
                  materialsList?.filter(material => formData.moment === material.moment || formData.actionType === material.action).map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}
                    >
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel shrink id={`label-activity`}>
                {getLocalizedString("activity")}
              </InputLabel>
              <Select
                displayEmpty
                value={formData.activity}
                labelId={`label-activity`}
                id={`activity`}
                onChange={(e) => setFormValue(e.target.value, "activity")}
                margin={"none"}
              >
                <MenuItem
                  className={"whiteText"}
                  value={""}
                >
                  {getLocalizedString("noneFemale")}
                </MenuItem>
                {
                  activityList?.map((item) => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}
                    >
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={12} justify={"flex-end"} alignItems="center" >
            <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("saveStep")} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Form;
